const DEFAULT_MONOGRAM_IMAGE_POSITION_STYLE = {
  position: "absolute",
  width: "auto",
};

const DEFAULT_MONOGRAM_TEXT_POSITION_STYLE = {
  position: "absolute",
  display: "flex",
  width: "100%",
};

export const MONOGRAM_POSITION_STYLES = {
  Center: {
    image: {
      ...DEFAULT_MONOGRAM_IMAGE_POSITION_STYLE,
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
    },
    text: {
      ...DEFAULT_MONOGRAM_TEXT_POSITION_STYLE,
      top: "50%",
      left: "0",
      transform: "translate(0, -50%)",
      justifyContent: "center",
    },
  },
  "Center & Top": {
    image: {
      ...DEFAULT_MONOGRAM_IMAGE_POSITION_STYLE,
      top: "0",
      left: "50%",
      transform: "translate(-50%, 0)",
    },
    text: {
      ...DEFAULT_MONOGRAM_TEXT_POSITION_STYLE,
      top: "0",
      left: "0",
      transform: "translate(0, 0)",
      justifyContent: "center",
    },
  },
  "Center & Bottom": {
    image: {
      ...DEFAULT_MONOGRAM_IMAGE_POSITION_STYLE,
      bottom: "0",
      left: "50%",
      transform: "translate(-50%, 0)",
    },
    text: {
      ...DEFAULT_MONOGRAM_TEXT_POSITION_STYLE,
      bottom: "0",
      left: "0",
      justifyContent: "center",
    },
  },
  "Center & Left": {
    image: {
      ...DEFAULT_MONOGRAM_IMAGE_POSITION_STYLE,
      top: "50%",
      left: "0",
      transform: "translate(0, -50%)",
    },
    text: {
      ...DEFAULT_MONOGRAM_TEXT_POSITION_STYLE,
      top: "50%",
      left: "0",
      transform: "translate(0, -50%)",
      justifyContent: "flex-start",
    },
  },
  "Center & Right": {
    image: {
      ...DEFAULT_MONOGRAM_IMAGE_POSITION_STYLE,
      top: "50%",
      right: "0",
      transform: "translate(0, -50%)",
    },
    text: {
      ...DEFAULT_MONOGRAM_TEXT_POSITION_STYLE,
      top: "50%",
      right: "0",
      transform: "translate(0, -50%)",
      justifyContent: "flex-end",
    },
  },
  "Top & Left": {
    image: { ...DEFAULT_MONOGRAM_IMAGE_POSITION_STYLE, top: "0", left: "0" },
    text: {
      ...DEFAULT_MONOGRAM_TEXT_POSITION_STYLE,
      top: "0",
      left: "0",
      justifyContent: "flex-start",
    },
  },
  "Top & Right": {
    image: { ...DEFAULT_MONOGRAM_IMAGE_POSITION_STYLE, top: "0", right: "0" },
    text: {
      ...DEFAULT_MONOGRAM_TEXT_POSITION_STYLE,
      top: "0",
      right: "0",
      justifyContent: "flex-end",
    },
  },
  "Bottom & Left": {
    image: { ...DEFAULT_MONOGRAM_IMAGE_POSITION_STYLE, bottom: "0", left: "0" },
    text: {
      ...DEFAULT_MONOGRAM_TEXT_POSITION_STYLE,
      bottom: "0",
      left: "0",
      justifyContent: "flex-start",
    },
  },
  "Bottom & Right": {
    image: { ...DEFAULT_MONOGRAM_IMAGE_POSITION_STYLE, bottom: "0", right: "0" },
    text: {
      ...DEFAULT_MONOGRAM_TEXT_POSITION_STYLE,
      bottom: "0",
      right: "0",
      justifyContent: "flex-end",
    },
  },
};

export const DRAWER_NAMES = {
  Calibration: "Calibration",
  Words: "Words",
  Initials: "Initials",
};

export const OVERLAYS = {
  Monogram: "Monogram",
  Exit: "Exit",
  WhatFits: "WhatFits",
};
